import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"
import BackgroundImage from "gatsby-background-image"
import Img from "gatsby-image"
import Slider from "react-slick"
import StyledSmallTitle from "../styled/styledSmallTitle"
import { StyledTitle } from "../Title"

const StyledSection = styled(BackgroundImage)`
  background-repeat: no-repeat;
  padding: 32px 16px 16px;
  z-index: 25;
  .slick-track {
    display: flex;
    margin-left: 0;
    .slick-slide {
      margin-right: 16px;
      @media (min-width: 768px) {
        margin-right: 30px;
      }
      @media (min-width: 1024px) {
        width: 370px !important;
      }
    }
  }
  .slick-list {
    padding: 0 12px !important;
  }
  .slick-slider {
    width: 100vw;
    margin-top: 40px;
    display: block;

    @media (min-width: 767px) {
      display: none;
    }
    @media (min-width: 1600px) {
      margin: 0 auto;
    }
  }
  @media (min-width: 768px) {
    padding: 60px 16px 50px;
  }
`
const Container = styled.div`
  @media (min-width: 768px) {
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    max-width: 900px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (min-width: 1200px) {
    max-width: 1200px;
  }
`

const Box = styled(BackgroundImage)`
  width: 242px;
  height: 177px;
  background-color: transparent !important;
  margin-bottom: 16px;
  &::before {
    border-radius: 8px;
  }
  @media (min-width: 768px) {
    margin-bottom: 30px;
  }
  @media (min-width: 1024px) {
    width: 370px;
    height: 270px;
  }
`
const ExtendedStyledTitle = styled(StyledTitle)`
  &::after {
    background-color: #f9d6c1;
  }
  @media (min-width: 768px) {
    text-align: center;
    &::after {
      left: 50%;
      transform: translateX(-50%);
    }
  }
  @media (min-width: 1024px) {
    margin-bottom: 40px;
  }
`

const ExtendedStyledSmallTitle = styled(StyledSmallTitle)`
  @media (min-width: 768px) {
    text-align: center;
  }
`

const GridContainer = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(3, minmax(170px, 370px));
    grid-template-rows: repeat(3, 270px);
  }
`

const StyledImage = styled(Img)`
  border-radius: 8px;
  margin: 16px;
  max-width: 370px;
`

const LastProjects = () => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    rows: 2,
    centerMode: true,
  }
  const {
    bg,
    biblia,
    comNet,
    dotyk,
    grawernia,
    koba,
    ulotki,
    tablicaClios,
    banerClios,
    wizytowki,
  } = useStaticQuery(graphql`
    query {
      bg: file(relativePath: { eq: "lastProjectsBg.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      biblia: file(relativePath: { eq: "realizacje/Biblia.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      comNet: file(relativePath: { eq: "realizacje/Com-net.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      dotyk: file(relativePath: { eq: "realizacje/Dotykpiekna.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      grawernia: file(relativePath: { eq: "realizacje/Grawernia.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      koba: file(relativePath: { eq: "realizacje/Kobadent.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      ulotki: file(relativePath: { eq: "realizacje/UlotkiDotyk.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      tablicaClios: file(relativePath: { eq: "realizacje/TablicaClios.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      banerClios: file(relativePath: { eq: "realizacje/CliosBaner.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      wizytowki: file(relativePath: { eq: "realizacje/wizytowki.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <StyledSection
      fluid={bg.childImageSharp.fluid}
      Tag="section"
      id="realizacje"
    >
      <Container>
        <ExtendedStyledSmallTitle>OSTATNIE REALIZACJE</ExtendedStyledSmallTitle>
        <ExtendedStyledTitle light>
          <span>Zbiór ostatnich projektów</span> które zrealizowaliśmy.
        </ExtendedStyledTitle>
        <Slider {...settings}>
          <Box fluid={biblia.childImageSharp.fluid} Tag="div" />
          <Box fluid={comNet.childImageSharp.fluid} Tag="div" />
          <Box fluid={dotyk.childImageSharp.fluid} Tag="div" />
          <Box fluid={grawernia.childImageSharp.fluid} Tag="div" />
          <Box fluid={koba.childImageSharp.fluid} Tag="div" />
          <Box fluid={ulotki.childImageSharp.fluid} Tag="div" />
          <Box fluid={banerClios.childImageSharp.fluid} Tag="div" />
          <Box fluid={tablicaClios.childImageSharp.fluid} Tag="div" />
          <Box fluid={wizytowki.childImageSharp.fluid} Tag="div" />
        </Slider>
        <GridContainer>
          <StyledImage
            fluid={biblia.childImageSharp.fluid}
            title="Biblia marketingu beauty"
            alt="Projekt okładki książki"
          />
          <StyledImage
            fluid={comNet.childImageSharp.fluid}
            title="Com Net - serwis i salon komputerowy"
            alt="Strona internetowa wizytówka - Com Net"
          />
          <StyledImage
            fluid={dotyk.childImageSharp.fluid}
            title="Branding i pomoc w promowaniu firmy Dotyk Piękna"
            alt="Strona internetowa i branding - Dotyk Piękna"
          />
          <StyledImage
            fluid={grawernia.childImageSharp.fluid}
            title="Projekt sklepu internetowego zlokalizowanego w Dzierżoniowie - GrawerniaDDZ"
            alt="Sklep internetowy - Grawernia Dzierżoniów"
          />
          <StyledImage
            fluid={koba.childImageSharp.fluid}
            title="Kobadent - gabinet stomatologiczny w Dzierżoniowie"
            alt="Wizytówka gabinetu dentystycznego Kobadent w Dzierżoniowie"
          />
          <StyledImage
            fluid={ulotki.childImageSharp.fluid}
            title="Dotyk Piękna - projekt ulotek"
            alt="Oferta firmy Dotyk Piękna"
          />
          <StyledImage
            fluid={tablicaClios.childImageSharp.fluid}
            title="Clios - Branding - tablica reklamowa"
            alt="Tablica reklamowa Clios"
          />
          <StyledImage
            fluid={banerClios.childImageSharp.fluid}
            title="Clios - Branding - baner reklamowy"
            alt="Baner reklamowy Clios"
          />
          <StyledImage
            fluid={wizytowki.childImageSharp.fluid}
            title="Nis Media - Branding - wizytówki"
            alt="Nasz projekt wizytówek"
          />
        </GridContainer>
      </Container>
    </StyledSection>
  )
}

export default LastProjects
